<template>
    <div class="container chartBackGround" >
        <div  class="firstDiv">
            <div class="grid-content img2">
                <div class="staticTitle">预授信情况</div>
                <div class="staticContent">
                    <div>评分人数：<span style="color:#ff6600;font-weight: bold">{{monthStatistic.total}}</span>&nbsp;&nbsp;人</div>
                    <div>担保金额：<span  style="color:#ff6600;font-weight: bold">{{monthStatistic.price}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
            <div class="grid-content img3">
                <div class="staticTitle">人工评分情况</div>
                <div class="staticContent">
                    <div>评分人数：<span style="color:#ff6600;font-weight: bold">{{yearStatistic.total}}</span>&nbsp;&nbsp;人</div>
                    <div>担保金额：<span  style="color:#ff6600;font-weight: bold">{{yearStatistic.price}}</span>&nbsp;&nbsp;万元</div>
                </div>
            </div>
        </div>
        <div  class="secondDiv">
            <div class="chartTitle1">项目类别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-select
                  v-model="chooseType"
                  size="small"
                  popper-class="custom-header"
                  @change="onChooseTypeChange"
                  style="width: 160px;margin-left: 10px;"
                >
                    <el-option
                      :key="year"
                      label="按年份统计"
                      value="year"
                    />
                    <el-option
                      :key="month"
                      label="按月份统计"
                      value="month"
                    />
                </el-select>
                <el-date-picker
                    v-model="time"
                    size="small"
                    type="month"
                    :clearable="false"
                    v-if="chooseType==='month'"
                    style="width: 110px;margin-left: 20px;"
                    value-format="YYYY-MM"
                    @change="onMonthChange"
                    placeholder="选择月">
                </el-date-picker>
                <el-date-picker
                  v-model="timeY"
                  size="small"
                  type="year"
                  :clearable="false"
                  v-else
                  style="width: 110px;margin-left: 20px;"
                  value-format="YYYY"
                  @change="onYearChange"
                  placeholder="选择年">
                </el-date-picker>
            </div>
            <div class="echarts1" id="echarts1"></div>
        </div>
        <div  class="thirdDiv">
            <div class="custom-title">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="时间范围">
                        <el-date-picker
                          style="width:280px;"
                          v-model="dateRange"
                          type="daterange"
                          align="right"
                          value-format="YYYY-MM-DD"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="项目类别">
                        <el-select
                          v-model="chooseProjectNames"
                          multiple
                          clearable
                          collapse-tags
                          placeholder="默认全部"
                          popper-class="custom-header"
                          :max-collapse-tags="1"
                          style="width: 210px"
                        >
                            <el-option
                              v-for="item in projectNameArr"
                              :key="item.ProjectName"
                              :label="item.ProjectName"
                              :value="item.ProjectName"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getChartDataCustom">统计</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="echarts1" id="echarts2"></div>
        </div>
    </div>
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
</style>
